<template>
    <div class="score_breakdown">
        <div class="score_content">
            <div class="detail-box_operate">
                <div class="operate-filter">
                    <div class="operate-filter_label">选择实训:</div>

                    <el-select v-model="project_id" placeholder="请选择项目" @change="getStudentScoreDetial" clearable
                        style="width: 300px;">
                        <el-option v-for="projectItem in LessonPreparation" :label="projectItem.project_title"
                            :value="projectItem.id" :key="projectItem.id"></el-option>
                    </el-select>
                </div>

                <el-button type="primary" @click="$router.back()">返回</el-button>
            </div>
            <div class="score_header">
                <div class="header_left">
                    <span class="task_name">{{ name }}——得分明细</span>
                </div>
                <div class="hrader_right">
                    <div class="image">
                        <img v-if="student_avator" :src="student_avator" alt="">
                        <img v-else src="@/assets/images/user_img.png" alt="" />
                    </div>
                    <div class="student_name">{{ student_name }}</div>
                    <div class="score">{{ score }}分</div>
                </div>
            </div>
            <el-table :data="scoreDetialData" row-key="id" ref="questionTableRef" :tree-props="{ children: 'children' }"
                :default-expand-all="true" style="width: 100%;min-height: 600px;">
                <el-table-column prop="class_name" label="一级名称">
                    <template slot-scope="scope">
                        <div v-if="Number(scope.row.type) == 1">
                            {{ scope.row.class_name }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="topic_title" label="题目" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div v-if="Number(scope.row.type) == 2"
                            style="width: 100%;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;"
                            v-html="scope.row.topic_title"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="class_name" label="二级名称">
                    <template slot-scope="scope">
                        <div v-if="Number(scope.row.type) == 3">
                            {{ scope.row.class_name }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="topic_title" label="题目" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div v-if="Number(scope.row.type) == 4"
                            style="width: 100%;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;"
                            v-html="scope.row.topic_title"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="回答">
                    <template slot-scope="scope">
                        <div v-if="(Number(scope.row.type) == 2 || Number(scope.row.type) == 4)">
                            <div v-if="(scope.row.topic_type == 1 || scope.row.topic_type == 3)">
                                <span v-if="scope.row.stu_answer !== ''"> {{
                                    scope.row.topic_options[scope.row.stu_answer].name
                                    }}</span>
                                <span v-else style="color: #f56c6c;">未作答</span>
                            </div>
                            <div v-else-if="scope.row.topic_type == 2">
                                <div v-if="scope.row.stu_answer.length > 0"
                                    style="display: flex;flex-direction: column;">
                                    <span v-for="item in scope.row.stu_answer">{{
                                        scope.row.topic_options[item].name }}</span>
                                </div>
                                <div v-else style="color: #f56c6c;">未作答</div>

                            </div>
                            <div v-else-if="scope.row.topic_type == 4">
                                <div v-if="scope.row.stu_answer.every(item => item.value === '')"
                                    style="color: #f56c6c;">
                                    未作答
                                </div>
                                <div v-else style="display: flex;flex-wrap: wrap;">
                                    <span v-for="item in scope.row.stu_answer" style="margin-right: 5px;">{{
                                        item.value }}</span>
                                </div>

                            </div>
                            <div v-else>
                                <span v-if="scope.row.stu_answer">
                                    <el-tooltip class="item" effect="dark" placement="top">
                                        <div slot="content" style=" max-width: 500px;"> {{ scope.row.stu_answer }}</div>
                                        <div class="ellipsis-text">
                                            {{ scope.row.stu_answer }}
                                        </div>
                                    </el-tooltip>
                                </span>
                                <span v-else style="color: #f56c6c;">未作答</span>
                            </div>
                        </div>
                        <!-- <div v-if="(Number(scope.row.type) == 2 || Number(scope.row.type) == 4) && (scope.row.topic_type==1 ||scope.row.topic_type==2 || scope.row.topic_type==3)">{{ scope.row.topic_options[stu_answer].name }}</div> -->
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="解析" v-if="role == 3">
                    <template slot-scope="scope">
                        <div v-if="(Number(scope.row.type) == 2 || Number(scope.row.type) == 4)">
                            <div v-if="(scope.row.topic_type == 1 || scope.row.topic_type == 3)">
                                <span v-if="scope.row.answer !== ''"> {{
                                    scope.row.topic_options[scope.row.answer].name
                                    }}</span>
                                <span v-else>暂无答案</span>
                            </div>
                            <div v-else-if="scope.row.topic_type == 2">
                                <div v-if="scope.row.answer.length > 0" style="display: flex;flex-direction: column;">
                                    <span v-for="item in scope.row.answer">{{
                                        scope.row.topic_options[item].name }}</span>
                                </div>
                                <div v-else>暂无答案</div>

                            </div>
                            <div v-else-if="scope.row.topic_type == 4">
                                <div v-if="scope.row.answer.every(item => item.value === '')">
                                    暂无答案
                                </div>
                                <div v-else style="display: flex;flex-wrap: wrap;">
                                    <span v-for="item in scope.row.answer" style="margin-right: 5px;">{{
                                        item.value }}</span>
                                </div>

                            </div>
                            <div v-else>
                                <span v-if="scope.row.answer">
                                    <el-tooltip class="item" effect="dark" placement="top">
                                        <div slot="content" style=" max-width: 500px;"> {{ scope.row.answer }}</div>
                                        <div class="ellipsis-text">
                                            {{ scope.row.answer }}
                                        </div>
                                    </el-tooltip>
                                </span>
                                <span v-else>暂无答案</span>
                            </div>
                        </div>
                        <!-- <div v-if="(Number(scope.row.type) == 2 || Number(scope.row.type) == 4) && (scope.row.topic_type==1 ||scope.row.topic_type==2 || scope.row.topic_type==3)">{{ scope.row.topic_options[stu_answer].name }}</div> -->
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="系统判定结果" width="160">
                    <template slot-scope="scope">
                        <div v-if="Number(scope.row.type) == 2 || Number(scope.row.type) == 4">
                            <!-- <span v-if="scope.row.topic_type!=5">{{ scope.row.is_true }}</span> -->
                            <div v-if="(scope.row.topic_type != 5 && scope.row.topic_type != 4)">
                                <span v-if="scope.row.is_true == 1"
                                    style="color: #67c23a;background: #f0f9eb; border: 1px solid #e1f3d8; border-radius: 4px;padding: 3px 6px;font-size: 12px;">正确</span>
                                <span v-if="scope.row.is_true == 0"
                                    style="color: #f56c6c;background: #fef0f0; border: 1px solid #fde2e2; border-radius: 4px;padding: 3px 6px;font-size: 12px;">错误</span>
                            </div>
                            <div v-if="scope.row.topic_type == 4">
                                <span v-if="scope.row.stu_score != 0"
                                    style="color: #67c23a;background: #f0f9eb; border: 1px solid #e1f3d8; border-radius: 4px;padding: 3px 6px;font-size: 12px;">正确</span>
                                <span v-else
                                    style="color: #f56c6c;background: #fef0f0; border: 1px solid #fde2e2; border-radius: 4px;padding: 3px 6px;font-size: 12px;">错误</span>
                            </div>
                            <div v-if="scope.row.topic_type == 5">
                                <span
                                    style="color: #909399;background: #f4f4f5; border: 1px solid #e9e9eb; border-radius: 4px;padding: 3px 6px;font-size: 12px;">教师评分</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="分值" width="120" align="center">
                    <template slot-scope="scope">
                        <!-- <div v-if="role == 3">
                            <div v-if="Number(scope.row.type) == 2 || Number(scope.row.type) == 4" style="width: 100%;">
                                <div v-if="(scope.row.topic_type != 5 && scope.row.topic_type != 4)"
                                    style="width: 100%;display: flex;align-items: center;justify-content: center;">{{
                                        scope.row.stu_score }}</div>
                                <div v-else>
                                    <el-input-number :precision="2" v-model="scope.row.stu_score" :controls="false"
                                        class="pw-input" :min="0" :max="scope.row.score"
                                        style="width: 60px;margin-right: 5px;">
                                    </el-input-number>
                                    / <span style="color: #606266; font-weight: 600;">{{ scope.row.score }}</span>
                                </div>
                            </div>
                        </div> -->
                        <div>{{ teacher_status == 0 && scope.row.topic_type == 5 ? '暂未评分' : scope.row.stu_score
                        }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <div class="footer_button" v-if="role == 3">
                <el-button round plain type="danger" @click="callBackReDo">打回重做</el-button>
                <el-button round type="primary" style="background: #409eff;border: 1px solid #409eff ;"
                    @click="submit">提交</el-button>
                <el-button round plain type="primary" @click="submitNext">提交并进入下一份</el-button>
            </div> -->
        </div>

    </div>
</template>

<script>
import _ from "underscore";

export default {
    name: "ScoreBreakdown",

    data() {
        return {
            scoreDetialData: [],
            student_name: "",
            student_avator: "",
            score: 0,
            role: 0,
            s_id: 0,
            teacher_status: 0,
            name: "",
            LessonPreparation: [],
            project_id: 0
        };
    },
    components: {
    },
    created() {
        this.s_id = localStorage.getItem("student_id") ? localStorage.getItem("student_id") : this.$route.query.s_id
        this.role = Number(localStorage.getItem("role"))
        this.student_name = this.$route.query.s_name
        this.student_avator = this.$route.query.s_icon
        this.getLessonPreparationList()
    },
    computed: {

    },
    watch: {},
    methods: {
        goBack() {
            this.$router.go(-1)
        },
        getStudentScoreDetial() {
            let params = {
                project_id: this.project_id,
                course_id: Number(localStorage.getItem("course_id")),
                course_chapter: this.role == 3 ? Number(localStorage.getItem("teacherChapter")) : Number(localStorage.getItem("studentChapter")),
                course_node: this.role == 3 ? Number(localStorage.getItem("teacherNode")) : Number(localStorage.getItem("studentNode")),
                c_id: this.role == 3 ? Number(localStorage.getItem("class_id")) : Number(localStorage.getItem("c_id")),
                s_id: this.s_id,
                type: Number(localStorage.getItem("project_type"))
            }
            if (Number(localStorage.getItem("project_type")) == 3) {
                delete params.course_id
                delete params.course_chapter
                delete params.course_node
            }
            if (Number(localStorage.getItem("project_type")) == 2) {
                params.course_chapter = -1
                params.course_node = -1
            }
            this.scoreDetialData = [];
            this.score = 0
            this.teacher_status = 0
            this.name = this.LessonPreparation.find((item) => item.id == this.project_id).project_title
            this.$shttp.axiosGetBy(this.$api.jdTrainingGetStuTopicDetail, params, (res) => {
                if (res.code === 200) {

                    // if (this.role == 3 && res.data.teacher_status == 0) {
                    //     res.data.topic_data.forEach(item => {
                    //         item.children.forEach(item1 => {
                    //             if (Number(item1.type) == 2) {
                    //                 if (item1.topic_type == 5 && item1.stu_score == 0) {
                    //                     item1.stu_score = void 0
                    //                 }
                    //             }
                    //             if (Number(item1.type) == 3) {
                    //                 item1.children.forEach(item3 => {
                    //                     if (item3.topic_type == 5 && item3.stu_score == 0) {
                    //                         item3.stu_score = void 0
                    //                     }
                    //                 })
                    //             }
                    //         })

                    //     });
                    // }
                    if (res.data.length == 0) return
                    this.scoreDetialData = res.data.topic_data;
                    this.score = res.data.score
                    this.teacher_status = res.data.teacher_status

                } else {
                    this.$message.error(res.msg)
                }
            }, (err) => {
                console.log(err)
            })
        },
        callBackReDo() {
            this.$confirm('打回后学生可重新参与实训', '是否确认打回？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    project_id: Number(localStorage.getItem("project_id")),
                    course_id: Number(localStorage.getItem("course_id")),
                    course_chapter: this.role == 3 ? Number(localStorage.getItem("teacherChapter")) : Number(localStorage.getItem("studentChapter")),
                    course_node: this.role == 3 ? Number(localStorage.getItem("teacherNode")) : Number(localStorage.getItem("studentNode")),
                    c_id: this.role == 3 ? Number(localStorage.getItem("class_id")) : Number(localStorage.getItem("c_id")),
                    s_id: this.s_id,
                    type: Number(localStorage.getItem("project_type"))
                }
                if (Number(localStorage.getItem("project_type")) == 3) {
                    delete params.course_id
                    delete params.course_chapter
                    delete params.course_node
                }
                if (Number(localStorage.getItem("project_type")) == 2) {
                    params.course_chapter = -1
                    params.course_node = -1
                }
                this.$shttp.axiosPost(this.$api.jdTrainingRepeat, params, (res) => {
                    if (res.code === 200) {
                        this.$message.success("操作成功")
                        this.$router.go(-1)
                    }
                })
            }).catch(() => {
            });

        },
        async submit() {
            return new Promise(async (resolve, reject) => {
                try {
                    await this.checkScoreDetailData(this);
                    this.$confirm('提交后将更新学生成绩', '是否确认提交？', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async () => {
                        try {
                            await this.submitFunction();
                            resolve();
                        } catch (submitError) {
                            reject(submitError);
                        }
                    }).catch(() => {
                        // 用户取消提交
                        reject(new Error('用户取消了提交'));
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },
        submitFunction() {
            let params = {
                project_id: Number(localStorage.getItem("project_id")),
                course_id: Number(localStorage.getItem("course_id")),
                course_chapter: this.role == 3 ? Number(localStorage.getItem("teacherChapter")) : Number(localStorage.getItem("studentChapter")),
                course_node: this.role == 3 ? Number(localStorage.getItem("teacherNode")) : Number(localStorage.getItem("studentNode")),
                c_id: this.role == 3 ? Number(localStorage.getItem("class_id")) : Number(localStorage.getItem("c_id")),
                s_id: this.s_id,
                type: Number(localStorage.getItem("project_type")),
                content: [...this.scoreDetialData]
            }
            if (Number(localStorage.getItem("project_type")) == 3) {
                delete params.course_id
                delete params.course_chapter
                delete params.course_node
            }
            if (Number(localStorage.getItem("project_type")) == 2) {
                params.course_chapter = -1
                params.course_node = -1
            }
            this.$shttp.axiosPost(this.$api.jdTrainingTeacherScore, params, (res) => {
                if (res.code === 200) {
                    this.$message.success("操作成功")
                    this.getStudentScoreDetial()
                }
            })

        },
        async checkScoreDetailData(context) {
            return new Promise((resolve, reject) => {
                for (const item of context.scoreDetialData) {
                    for (const item1 of item.children) {
                        if (Number(item1.type) === 2) {
                            if (item1.topic_type === 5 && item1.stu_score === undefined) {
                                context.$message.warning("教师评分不能为空");
                                reject(new Error("教师评分不能为空"));
                                return;
                            }
                        }
                        if (Number(item1.type) === 3) {
                            for (const item3 of item1.children) {
                                if (item3.topic_type === 5 && item3.stu_score === undefined) {
                                    context.$message.warning("教师评分不能为空");
                                    reject(new Error("教师评分不能为空"));
                                    return;
                                }
                            }
                        }
                    }
                }
                resolve();
            });
        },
        async submitNext() {
            try {
                // 等待 submit 函数执行完成
                await this.submit();
                let params = {
                    project_id: Number(localStorage.getItem("project_id")),
                    course_id: Number(localStorage.getItem("course_id")),
                    course_chapter: this.role == 3 ? Number(localStorage.getItem("teacherChapter")) : Number(localStorage.getItem("studentChapter")),
                    course_node: this.role == 3 ? Number(localStorage.getItem("teacherNode")) : Number(localStorage.getItem("studentNode")),
                    c_id: this.role == 3 ? Number(localStorage.getItem("class_id")) : Number(localStorage.getItem("c_id")),
                    s_id: this.s_id,
                    type: Number(localStorage.getItem("project_type"))
                }
                if (Number(localStorage.getItem("project_type")) == 3) {
                    delete params.course_id
                    delete params.course_chapter
                    delete params.course_node
                }
                if (Number(localStorage.getItem("project_type")) == 2) {
                    params.course_chapter = -1
                    params.course_node = -1
                }
                this.$shttp.axiosGetBy(this.$api.jdTrainingTeacherScoreNextStuId, params, (res) => {
                    if (res.code === 200) {

                        if (res.data.s_id) {
                            this.s_id = res.data.s_id
                            localStorage.setItem("student_id", this.s_id)
                            this.getStudentScoreDetial()
                        } else {
                            this.$confirm('没有下一份了', '已批阅完成', {
                                confirmButtonText: '确定',
                                type: 'warning'
                            }).then(() => {
                            }).catch(() => {
                            });
                        }

                    }
                })
            } catch (error) {
                console.error('submit 函数执行出错:', error);
            }
        },
        getLessonPreparationList() {
            let param = {
                course_chapter: Number(localStorage.getItem("teacherChapter")),
                course_node: Number(localStorage.getItem("teacherNode")),
                course_id: Number(localStorage.getItem("course_id"))
            }
            if (this.role === 3) {
                //先查询课程那边自定义/拖拽保存的实训列表
                this.$shttp.axiosGetBy(this.$api.course_getcoursecustom, param, (res) => {
                    if (res.code === 200) {
                        //没有数据的话就查询总管理员创建课程时拖拽保存的实训列表
                        if (res.data.length === 0) {
                            let params = {
                                id: Number(localStorage.getItem("course_id")),
                                chapter: Number(localStorage.getItem("teacherChapter")),
                                node: Number(localStorage.getItem("teacherNode"))
                            }
                            this.$shttp.axiosGetBy(this.$api.courseinfo, params, (res) => {
                                if (res.code === 200) {
                                    let project = res.data.projects;
                                    let courseContent = res.data.course_content.children;
                                    this.LessonPreparation = this.formatProject(project, courseContent);
                                    this.project_id = this.LessonPreparation.length != 0 ? this.LessonPreparation[0].id : null
                                    this.name = this.LessonPreparation.length != 0 ? this.LessonPreparation[0].project_title : ""
                                    this.getStudentScoreDetial()

                                } else {
                                    this.$message.error(res.msg);
                                }
                            }, (err) => {
                                console.log(err);
                            })
                        } else {
                            this.LessonPreparation = res.data.projects;
                            this.project_id = this.LessonPreparation.length != 0 ? this.LessonPreparation[0].id : null
                            this.name = this.LessonPreparation.length != 0 ? this.LessonPreparation[0].project_title : ""
                            this.getStudentScoreDetial()
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                }, (err) => {
                    console.log(err);
                })
            }
        },
        formatProject(projects, courseContent) {
            let reslist = [];
            //遍历出当前章节的资源
            _.each(courseContent, (item) => {
                _.each(projects, (item1) => {
                    if (item.type === 5) {
                        if (Number(item.id) === Number(item1.id)) {
                            reslist.push(item1);
                        }
                    }
                })
            })
            return reslist;
        },

    },
};
</script>

<style scoped lang="scss">
.score_breakdown {
    width: 100%;
    // height: calc(100vh - 112px);
    // background: #eff3fd;
    // padding: 20px 30px;
    box-sizing: border-box;
    overflow-y: auto;

    .score_content {
        width: 100%;
        // height: 100%;
        // border-style: solid;
        // border-color: #e5e7eb;
        box-shadow: 0 5px 10px 1px rgba(32, 32, 32, 0.05);
        padding: 20px;
        box-sizing: border-box;
        background: #fff;

        .detail-box_operate {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            // margin-top: 20px;
            margin-bottom: 20px;

            .operate-filter {
                display: flex;
                align-items: center;
                gap: 20px;

                &_label {
                    height: 30px;
                    font-family: PingFang-SC, PingFang-SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                    line-height: 30px;
                    flex-shrink: 0;
                }

                ::v-deep .el-input__inner {
                    background-color: transparent !important;
                    height: 40px !important;
                }
            }

            .el-button {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 88px;
                height: 36px;
            }
        }

        .score_header {
            align-items: center;
            display: flex;
            justify-content: space-between;
            line-height: 24px;
            padding-bottom: 20px;
            border-bottom: 1px solid #e4e7ed;

            .header_left {
                display: flex;
                align-items: center;

                .el-icon-back {
                    color: #323335;
                    cursor: pointer;
                }

                .back_name {
                    color: #303133;
                    font-size: 14px;
                    margin: 0 10px;
                    cursor: pointer;
                }

                .line {
                    border-left: 1px solid #dcdfe6;
                    display: inline-block;
                    height: 1em;
                    margin: 0 8px;
                    position: relative;
                    vertical-align: middle;
                    width: 1px;
                }

                .task_name {
                    color: #303133;
                    font-size: 18px;
                    font-weight: 600;
                }
            }

            .hrader_right {
                display: flex;
                align-items: center;

                .image {
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;

                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        object-fit: cover;
                    }

                }

                .student_name {
                    color: #4b5563;
                    font-size: 16px;
                    margin: 0 10px;
                }

                .score {
                    color: #dc2626;
                    font-size: 16px;
                }
            }
        }


    }

}

.footer_button {
    display: flex;
    height: 100px;
    align-items: center;
    justify-content: center;

    .el-button {
        width: 140px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

::v-deep .el-input__inner {
    height: 30px !important;
    background: #fff !important;
}

::v-deep .el-table .cell {
    display: flex;
    align-items: center;
}

.ellipsis-text {
    width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 设置滚动条整体 */
::-webkit-scrollbar {
    width: 3px;
    /* 滚动条宽度 */
    height: 6px;
    /* 水平滚动条高度 */
}

/* 设置滚动条轨道 */
::-webkit-scrollbar-track {
    background: #f1f1f1;
    /* 轨道背景色 */
}

/* 设置滚动条滑块 */
::-webkit-scrollbar-thumb {
    background: #d3d2d2;
    /* 滑块背景色 */
    border-radius: 6px;
    /* 滑块圆角 */
}

/* 设置滚动条滑块悬停时的样式 */
::-webkit-scrollbar-thumb:hover {
    background: #555;
    /* 滑块悬停背景色 */
}
</style>
